import context from '@/context'
import { fromUtcDate } from '@/utils/dateUtilities'
import { actionCreators as colissionActionCreators } from './ReportingCycleCollisions'
import find from 'lodash/find'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

export const initialState = {

  creating: false,
  retrieving: false,
  deleting: false,
  reportingCycle: null,
  componentKey: getComponentKey()
}

export const actionTypes = {

  creating: 'reportingCycle/creating',
  created: 'reportingCycle/created',
  retrieving: 'reportingCycle/retrieving',
  retrieved: 'reportingCycle/retrieved',
  updating: 'reportingCycle/updating',
  updated: 'reportingCycle/updated',
  deleting: 'reportingCycle/deleting',
  deleted: 'reportingCycle/deleted',
  error: 'reportingCycle/error'
}

export const actionCreators = {
  create: (input) => (dispatch) => {
    dispatch({ type: actionTypes.creating })
    context.api.reportingCyclesService.create(input, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.created })
        if (input.id > 0) {
          dispatch(actionCreators.get(input.id))
          dispatch(colissionActionCreators.getCollisionDates(input.id))
        }
      }).catch(() => dispatch({ type: actionTypes.error, update: { creating: false } }))
  },
  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.retrieving, data: id })
    context.api.reportingCyclesService.get(id, allowErrorDialog)
      .then(reportingCycle => {
        reportingCycle.submissions = reportingCycle.submissions.map(submission => {
          submission.snapshotDate = fromUtcDate(submission.snapshotDate)
          submission.dueDate = fromUtcDate(submission.dueDate)
          submission.extendedDueDate = fromUtcDate(submission.extendedDueDate)

          return submission
        })
        if (reportingCycle.snapshotDateValue) {
          reportingCycle.snapshotDateValue = fromUtcDate(reportingCycle.snapshotDateValue)
        }
        if (reportingCycle.dueDateValue) {
          reportingCycle.dueDateValue = fromUtcDate(reportingCycle.dueDateValue)
        }
        dispatch({ type: actionTypes.retrieved, data: reportingCycle })
      }).catch(() => dispatch({ type: actionTypes.error, update: { retrieving: false } }))
  },
  update: (submission) => (dispatch) => {
    dispatch({ type: actionTypes.updating, data: submission, updating: true })
    context.api.reportingCyclesService.updateSubmission(submission, allowErrorDialog)
      .then(response => {
        if (response === true) {
          dispatch({ type: actionTypes.updated, data: submission })
          dispatch(colissionActionCreators.getCollisionDates(submission.reportingCycleId))
        }
      }).catch(() => dispatch({ type: actionTypes.updating, data: submission, updating: false }))
  },
  delete: (id) => (dispatch) => {
    dispatch({ type: actionTypes.deleting })
    context.api.reportingCyclesService.delete(id, allowErrorDialog)
      .then(() => {
        dispatch({ type: actionTypes.deleted })
      }).catch(() => dispatch({ type: actionTypes.error, update: { deleting: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.creating: return { ...state, creating: true }
    case actionTypes.created: return { ...state, creating: false, componentKey: getComponentKey(), isCreateNewDialogOpen: false }
    case actionTypes.retrieving: return { ...state, retrieving: true }
    case actionTypes.retrieved: return { ...state, retrieving: false, reportingCycle: action.data, componentKey: getComponentKey() }
    case actionTypes.updating: {
      const updatedSubmission = find(state.reportingCycle.submissions, x => x.id === action.data.id)
      if (updatedSubmission) {
        return { ...state, reportingCycle: updateSubmission(state.reportingCycle, { ...updatedSubmission, updating: action.updating }) }
      }
      return state
    }
    case actionTypes.updated: return { ...state, reportingCycle: updateSubmission(state.reportingCycle, { ...action.data, updating: false, updated: true }) }
    case actionTypes.deleting: return { ...state, deleting: true }
    case actionTypes.deleted: return { ...state, deleting: false, componentKey: getComponentKey() }
    case actionTypes.error: return { ...state, ...action.update }
    default: return state
  }
}

export const updateSubmission = (reportingCycle, updatedSubmission) => {
  const submissions = reportingCycle.submissions.map(submission => submission.id === updatedSubmission.id ? updatedSubmission : submission)
  return { ...reportingCycle, submissions }
}



// WEBPACK FOOTER //
// ./src/store/reportingCycles.js